export const EDIT_FIELD_FOR_MODAL = 'EDIT_FIELD_FOR_MODAL';
export const CLEAR_EDIT_MODAL_STATE = 'CLEAR_EDIT_MODAL_STATE';
export const START_EDIT = 'START_MODAL_EDIT_IN_PROFILE';
export const START_INLINE_EDIT = 'START_INLINE_EDIT_IN_PROFILE';



// WEBPACK FOOTER //
// ./src/app/stores/profile-edit-modal/profile-edit-modal-constants.js